import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';


const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="relative text-white"
      style={{ background: '#020405' }}
    >
      <div className="container-custom py-16 pt-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Company */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img src="/logo-white.png" alt="LAIzyones – KI-Agentur" className="h-12 object-contain" />
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Ihre KI-Agentur aus Magdeburg und Braunschweig. Wir helfen Unternehmen deutschlandweit, mit KI effizienter zu arbeiten.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://www.instagram.com/laizyones/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-gray-500 hover:text-emerald-400 hover:border-emerald-500/30 transition-all">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a href="https://de.linkedin.com/company/laizyones" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-gray-500 hover:text-emerald-400 hover:border-emerald-500/30 transition-all">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
            </div>
          </div>

          {/* Leistungen */}
          <div>
            <h4 className="font-['Space_Grotesk'] font-semibold text-sm text-white uppercase tracking-wider mb-5">Leistungen</h4>
            <ul className="space-y-3">
              {[
                { label: 'Prozessanalyse & Automatisierung', to: '/prozessanalyse' },
                { label: 'KI-Tool-Entwicklung', to: '/ki-tool-entwicklung' },
                { label: 'Geschäftsideen & Start-Ups', to: '/geschaeftsideen' },
                { label: 'Systeme & Landingpages', to: '/systeme-landingpages' },
                { label: 'Individuelle Lösungen', to: '/individuelle-loesungen' },
              ].map(l => (
                <li key={l.to}><Link to={l.to} className="text-gray-500 text-sm hover:text-emerald-400 transition-colors duration-200">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-['Space_Grotesk'] font-semibold text-sm text-white uppercase tracking-wider mb-5">Unternehmen</h4>
            <ul className="space-y-3">
              {[
                { label: 'Startseite', to: '/' },
                { label: 'KI-Produkte', to: '/produkte' },
                { label: 'Über uns', to: '/ueber-uns' },
              ].map(l => (
                <li key={l.to}><Link to={l.to} className="text-gray-500 text-sm hover:text-emerald-400 transition-colors duration-200">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Space_Grotesk'] font-semibold text-sm text-white uppercase tracking-wider mb-5">Kontakt</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-gray-500">
                <Mail className="w-4 h-4 text-emerald-500/60 flex-shrink-0" />
                <a href="mailto:info@laizyones.de" className="hover:text-emerald-400 transition-colors">info@laizyones.de</a>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-500">
                <Phone className="w-4 h-4 text-emerald-500/60 flex-shrink-0" />
                <a href="tel:+491721771141" className="hover:text-emerald-400 transition-colors">0172 1771141</a>
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-500">
                <MapPin className="w-4 h-4 text-emerald-500/60 mt-0.5 flex-shrink-0" />
                <span>Magdeburg & Braunschweig<br />Deutschlandweit tätig</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-['Space_Grotesk'] font-semibold text-sm text-white uppercase tracking-wider mb-5">Rechtliches</h4>
            <ul className="space-y-3">
              {[
                { label: 'Impressum', to: '/impressum' },
                { label: 'Datenschutz', to: '/datenschutz' },
                { label: 'AGB', to: '/agb' },
              ].map(l => (
                <li key={l.label}><Link to={l.to} className="text-gray-500 text-sm hover:text-emerald-400 transition-colors duration-200">{l.label}</Link></li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-gray-600">&copy; {currentYear} LAIzyones. Alle Rechte vorbehalten. | KI-Agentur Magdeburg & Braunschweig</p>
            <div className="flex items-center gap-6">
              {[
                { label: 'Impressum', to: '/impressum' },
                { label: 'Datenschutz', to: '/datenschutz' },
                { label: 'AGB', to: '/agb' },
              ].map(l => (
                <Link key={l.label} to={l.to} className="text-xs text-gray-600 hover:text-emerald-400 transition-colors">{l.label}</Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
